import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { SwalService } from '@shared/utils/swal.service';
import { Cuestionario, CuestionarioRequest, CuestionarioResponse, EliminarCuestionarioRequest } from './interfaces/cuestionario.interface';
import { CuestionariosService } from './services/cuestionarios.service';

@Component({
  selector: 'app-cuestionarios',
  templateUrl: './cuestionarios.component.html',
  providers: [MessageService]
})
export class CuestionariosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  dataSource: Cuestionario[] = [];
  displayedColumns: any[] = [
    { field: 'sClaveCues', header: 'Clave Cuestionario', sortable: true },
    { field: 'sDescripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];
  loading: boolean = false;
  rows: number = 15;
  first: number = 0;
  totalRecords: number = 0;
  globalFilter: string = '';

  displayDialog: boolean = false;
  selectedCuestionario: Cuestionario | null = null;
  displayCopiarDialog: boolean = false;

  constructor(
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService,
    private swalService: SwalService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: CuestionarioRequest = {
      que: "0",
      tope: "999",
      cmd: "",
      sClave: "",
      sDescripcion: "",
      iTipo: 0,
      iGestion: 0,
      bTodos: 0
    };

    this.cuestionariosService.getCuestionarios(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los cuestionarios'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los cuestionarios'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  onFilter(event: any): void {
    this.globalFilter = event.filteredValue;
  }

  openCreate(): void {
    this.selectedCuestionario = null;
    this.displayDialog = true;
  }

  openUpdate(rowData: Cuestionario): void {
    this.selectedCuestionario = rowData;
    this.displayDialog = true;
  }

  onDialogClosed(event?: {refresh: boolean, success?: boolean}) {
    this.displayDialog = false;
    this.selectedCuestionario = null;
    if (event) {
      if (event.success === true) {
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Cuestionario guardado correctamente'
        });
      } else if (event.success === false) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo guardar el cuestionario'
        });
      }
      if (event.refresh) {
        this.loadData();
      }
    }
  }

  delete(rowData: Cuestionario): void {
    import('sweetalert2').then(Swal => {
      Swal.default.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro de eliminar el cuestionario ${rowData.sClaveCues}?`,
        icon: 'warning',
        showCancelButton: true,
        iconColor: "#d33",
        confirmButtonColor: "#d33",
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.loading = true;
          const request: EliminarCuestionarioRequest = {
            que: 3,
            sClave: rowData.sClaveCues,
            sDescripcion: "",
            iTipo: 0,
            iGestion: 0,
            bTodos: 0
          };

          this.cuestionariosService.eliminarCuestionario(request).subscribe({
            next: (response) => {
              if (response.success && response.data.error === 0) {
                this.globalFilter = '';
                if (this.table) this.table.clear();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Cuestionario eliminado correctamente'
                });
                this.loadData();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No se pudo eliminar el cuestionario'
                });
              }
            },
            error: (error) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el cuestionario'
              });
              console.error('Error:', error);
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    });
  }

  openCopiarDialog(): void {
    this.displayCopiarDialog = true;
  }

  onCopiarDialogClosed(event?: any): void {
    this.displayCopiarDialog = false;
    if (event) {
      if (event.success) {
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: event.message
        });
        this.loadData();
      } else if (event.error) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: event.error
        });
      }
    }
  }
} 